// src/Dashboard/pages/user/ArbitrageJudo/components/ArbitrageToolbar.jsx

import React from "react";
import { FaSearch, FaTimes } from "react-icons/fa";

export default function ArbitrageToolbar({
  search,
  onSearchChange,
  categories = [],
  activeCategory,
  onCategoryChange,
  resultsCount = 0,
}) {
  return (
    <div className="border-b border-slate-200 p-4 dark:border-slate-800 sm:p-5">
      <div className="flex flex-col gap-4">
        <div className="grid gap-3 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center">
          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              type="text"
              value={search}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder="Rechercher : ippon, shido, matte, yuko, golden score..."
              className="w-full rounded-2xl border border-slate-200 bg-white py-3 pl-11 pr-12 text-sm font-medium text-slate-900 outline-none transition focus:border-indigo-300 focus:ring-4 focus:ring-indigo-100 dark:border-slate-700 dark:bg-slate-950 dark:text-white dark:focus:ring-indigo-900/30"
            />

            {search && (
              <button
                type="button"
                onClick={() => onSearchChange("")}
                className="absolute right-3 top-1/2 inline-flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-xl bg-slate-100 text-slate-500 transition hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700"
              >
                <FaTimes />
              </button>
            )}
          </div>

          <div className="rounded-2xl bg-slate-50 px-4 py-3 text-center text-sm font-bold text-slate-600 ring-1 ring-slate-200 dark:bg-slate-800/60 dark:text-slate-300 dark:ring-slate-700">
            {resultsCount} résultat{resultsCount > 1 ? "s" : ""}
          </div>
        </div>

        <div className="flex gap-2 overflow-x-auto pb-1">
          {categories.map((category) => {
            const active = activeCategory === category;

            return (
              <button
                key={category}
                type="button"
                onClick={() => onCategoryChange(category)}
                className={`shrink-0 rounded-full px-4 py-2 text-sm font-bold transition ${
                  active
                    ? "bg-[#013E8E] text-white shadow-sm"
                    : "bg-slate-50 text-slate-600 ring-1 ring-slate-200 hover:bg-slate-100 dark:bg-slate-800/60 dark:text-slate-300 dark:ring-slate-700 dark:hover:bg-slate-800"
                }`}
              >
                {category}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}